import { useState, useEffect } from "react";
import { api, type ContactInquiry } from "@/lib/api";

export default function ContactosPage() {
  const [items, setItems] = useState<ContactInquiry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    api
      .getContacts()
      .then(setItems)
      .catch((err) => {
        setItems([]);
        setError(err instanceof Error ? err.message : "No se pudieron cargar los contactos");
      })
      .finally(() => setLoading(false));
  }, []);

  const filtered = items.filter((i) => {
    const matchType = !typeFilter || i.type === typeFilter;
    const q = search.toLowerCase();
    const matchSearch =
      !q ||
      i.name.toLowerCase().includes(q) ||
      i.email.toLowerCase().includes(q) ||
      i.message.toLowerCase().includes(q) ||
      (i.company || "").toLowerCase().includes(q);
    return matchType && matchSearch;
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Bandeja de contacto</h1>
        <p className="text-sm text-[var(--color-text-muted)]">
          Consultas del formulario público (Empresa e Independientes)
        </p>
      </div>
      <div className="card flex gap-3 flex-wrap">
        <input
          className="input-field flex-1 min-w-[200px]"
          placeholder="Buscar por nombre, email, empresa o mensaje..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select className="input-field w-40" value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
          <option value="">Todos</option>
          <option value="b2b">Empresa</option>
          <option value="b2c">Independiente</option>
        </select>
        <span className="text-xs text-[var(--color-text-muted)] self-center">{filtered.length} de {items.length}</span>
      </div>
      {loading ? (
        <div className="text-center py-12">
          <i className="ri-loader-4-line animate-spin text-2xl"></i>
        </div>
      ) : error ? (
        <div className="card text-center py-12">
          <i className="ri-error-warning-line text-3xl text-red-400"></i>
          <p className="text-red-400 mt-3">{error}</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="card text-center py-12 space-y-2">
          <i className="ri-mail-unread-line text-4xl text-[var(--color-text-muted)]"></i>
          <p className="text-[var(--color-text-muted)]">Sin mensajes en la bandeja</p>
          <p className="text-xs text-[var(--color-text-muted)] max-w-md mx-auto">
            Los contactos llegan desde el formulario de la página de inicio (sección Contacto).
            Empresa (B2B) e Independiente (B2C) quedan registrados aquí.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {filtered.map((i) => (
            <div key={i.id} className="card">
              <div className="flex justify-between gap-4 flex-wrap">
                <div>
                  <span className={`badge-${i.type === "b2b" ? "info" : "accent"} text-[10px] mr-2`}>
                    {i.type === "b2b" ? "EMPRESA" : "INDEPENDIENTE"}
                  </span>
                  <span className="font-semibold">{i.name}</span>
                  <p className="text-sm text-[var(--color-text-muted)]">
                    {i.email} · {i.phone || "—"}
                  </p>
                  {i.company && (
                    <p className="text-xs text-[var(--color-text-secondary)]">
                      {i.company} — {i.position}
                    </p>
                  )}
                </div>
                <p className="text-xs text-[var(--color-text-muted)]">
                  {new Date(i.created_at).toLocaleString("es-MX")}
                </p>
              </div>
              <p className="mt-3 text-sm text-[var(--color-text-secondary)] whitespace-pre-wrap">{i.message}</p>
              <a href={`mailto:${i.email}`} className="text-xs text-[var(--color-accent)] mt-3 inline-block hover:underline">
                Responder por email
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
